import {Page} from "@/libwyze-shared/types";
import React, {ReactElement, useEffect, useState} from "react";
import {Box, Card, CircularProgress, Typography, useTheme} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinScreenType, CheckinState} from "./CheckinPlayerPreviewFragment";
import {CheckinLargeButton} from "@/checkin-shared/Components";
import {ArrowForwardOutlined} from "@mui/icons-material";
import {BORDER_RADIUS_MEDIUM, PD_LG, PD_MD, PD_XLG2, SZ_MD} from "@/shared/dimens";
import {ProfilePhoto} from "@/shared/types";

type PatientProfileData = {
  displayName: string,
  profilePhoto: string,
  dateOfBirth: string,
  phoneNumber: string,
};

export function ProfileConfirmScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
}): ReactElement {
  const theme = useTheme();
  const [profile, setProfile] = useState<PatientProfileData>();
  useEffect(() => {
    (async function () {
      setProfile(null);
      // TODO: load patient profile by phone number
    })();
  }, []);
  return profile !== undefined
    ? (Boolean(profile)
      ? <>
        <StyledBoxColumn style={{alignItems: "flex-start", gap: 0}}>
          <Typography variant={"h2"} style={{fontWeight: 900}}>
            Is this you?
          </Typography>
          <Typography style={{fontSize: "100%", opacity: 0.5}}>
            Please confirm the details below.
          </Typography>
        </StyledBoxColumn>
        <Box style={{
          width: "100%",
          borderRadius: BORDER_RADIUS_MEDIUM,
          backgroundColor: theme.palette.grey[100],
          padding: PD_LG,
        }}>
          <StyledBoxRow style={{alignItems: "start", gap: PD_LG}}>
            <Card style={{width: SZ_MD, height: SZ_MD, flexShrink: 0}}>
              <img src={ProfilePhoto(profile.profilePhoto)}
                   style={{width: "100%", height: "100%", objectFit: "cover"}}/>
            </Card>
            <StyledBoxColumn style={{flex: 1}}>
              <Typography variant="h5" style={{fontWeight: 700}}>
                {profile.displayName}
              </Typography>
              <Typography style={{opacity: 0.5}}>
                {profile.dateOfBirth} · {profile.phoneNumber}
              </Typography>
            </StyledBoxColumn>
          </StyledBoxRow>
        </Box>
        <StyledBoxRow style={{gap: PD_MD}}>
          <CheckinLargeButton
            endIcon={<ArrowForwardOutlined style={{fontSize: "125%"}}/>}
            onClick={() => {
              props.pushScreenType(CheckinScreenType.VISIT_REASON);
            }}>
            Yes, that's me
          </CheckinLargeButton>
          <CheckinLargeButton
            variant="outlined"
            onClick={() => {
              props.pushScreenType(CheckinScreenType.ENTER_PHONE_NUMBER);
            }}>
            That's not me
          </CheckinLargeButton>
        </StyledBoxRow>
        <StyledSpan/>
      </>
      : <StyledBoxColumn style={{flexGrow: 1, gap: PD_XLG2, alignItems: "center", justifyContent: "center"}}>
        <Typography style={{textAlign: "center"}} variant={"h4"}>
          Profile not found
        </Typography>
        <Typography style={{textAlign: "center"}}>
          Please approach the reception for help or try again.
        </Typography>
        <CheckinLargeButton
          variant="outlined"
          onClick={() => {
            props.pushScreenType(CheckinScreenType.ENTER_PHONE_NUMBER);
          }}>
          Try again
        </CheckinLargeButton>
      </StyledBoxColumn>)
    : <CircularProgress/>;
}
